import {Typography} from '~library/atoms/Typography';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {pebble} from '~libSass/base/_exports.sass';

export type Registry = {
  id?: string;
  email_reg_button_url?: string;
  icon_url?: string;
  iconUrl?: string;
  name: string;
  sg_icon_url?: string;
  type?: string;
  url: string;
  vendor_name?: string;
  vendorName?: string;
};

type RegistryVendorProps = {
  type: string;
  registry: Registry;
  dataQaId: string;
};

export const RegistryVendor = ({type, registry, dataQaId}: RegistryVendorProps) => {
  const {name} = registry;
  const iconUrl = registry.iconUrl || registry.icon_url;
  const vendorName = registry.vendorName || registry.vendor_name || registry.name;

  let displayName = name;
  if (vendorName) {
    displayName = vendorName.includes('registry')
      ? vendorName.replace('registry', type)
      : `${vendorName} ${type}`;
  }

  return (
    <div className="view-invitation__registry-vendor__wrapper">
      <a
        href={registry.url || ''}
        className="view-invitation__registry-vendor"
        target="_blank"
        data-qa-id={dataQaId}
        data-impression-tracking="true"
        rel="noreferrer"
      >
        <img src={iconUrl} alt={vendorName} />
        <Typography
          variant="paragraph2"
          className="view-invitation__registry-vendor__title"
          semibold
        >
          View the {displayName}
          <ChevronIcon color={pebble} ratio={0.5} />
        </Typography>
      </a>
    </div>
  );
};
